import { render, staticRenderFns } from "./Pad.vue?vue&type=template&id=8ceec42e"
import script from "./Pad.vue?vue&type=script&lang=ts"
export * from "./Pad.vue?vue&type=script&lang=ts"
import style0 from "./Pad.vue?vue&type=style&index=0&id=8ceec42e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports